import React from "react";
import TainanLogo from "../images/partners_tainan.svg";
import PixnetLogo from "../images/partners_pixnet.svg";
import KkdayLogo from "../images/partners_kkday.svg";
import ReadygoLogo from "../images/partners_readygo.svg";
import CoolLogo from "../images/partners_cool.svg";
import BudgetLogo from "../images/partners_budget.svg";
import AvisLogo from "../images/partners_avis.svg";

const Partners = () => {
    return (
        <section
            className="partners"
            data-aos="fade-in"
            data-aos-easing="linear"
            data-aos-duration="1000"
        >
            <h3>主辦單位</h3>
            <div className="logo">
                <img src={TainanLogo} width={82} height={71} alt="tainan-logo" />
                <img src={PixnetLogo} width={99} height={42} alt="pixnet-logo" />
            </div>
            <h3>合作夥伴</h3>
            <div className="logo">
                <a href="https://www.kkday.com/zh-tw/affiliate/whlb/chillwaytainan" target="_blank" rel="noreferrer">
                    <img src={KkdayLogo} width={91} height={35} alt="kkday-logo" />
                </a>
                <a href="https://imreadygo.com/tainan2023/" target="_blank" rel="noreferrer">
                    <img src={ReadygoLogo} width={118} height={35} alt="readygo-logo" />
                </a>
                <a href="https://coolprice.com.tw/theme/2" target="_blank" rel="noreferrer">
                    <img src={CoolLogo} width={99} height={35} alt="cool-logo" />
                </a>
                <a href="https://coolprice.com.tw/theme/2" target="_blank" rel="noreferrer">
                    <img src={BudgetLogo} width={80} height={35} alt="budget-logo" />
                </a>
                <a href="https://coolprice.com.tw/theme/2" target="_blank" rel="noreferrer">
                    <img src={AvisLogo} width={65} height={35} alt="avis-logo" />
                </a>
            </div>
            <p>
                感謝<a href="https://www.twtainan.net/" target="_blank" rel="noreferrer">台南旅遊網</a>、各大飯店及網友提供百大熱搜精美照片<br />
                此活動若有問題請寄信至活動信箱：<a href="mailto:chill-tainan@pixnet.tw" rel="noreferrer">chill-tainan@pixnet.tw</a>
            </p>
        </section>
    );
};

export default Partners;
